"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleFunction = void 0;
const defaults_1 = require("../../defaults");
// --------- Handle Function --------
const handleFunction = (props, pack, moveOn, func) => {
    const { timeBeforeDelete } = props;
    const { current: contentCurrent } = pack.contentRef;
    if (!contentCurrent) {
        return;
    }
    const rotateDataIndex = pack.currentDataRotateIndex % pack.copyDataToRotate.length;
    const textBlocks = pack.copyDataToRotate[rotateDataIndex];
    func();
    if (pack.blockPointer === textBlocks.length - 1) {
        // If current action is the last block, set wait time to timeBeforeDelete
        pack.isDeleting = true;
        const waitTime = timeBeforeDelete !== null && timeBeforeDelete !== void 0 ? timeBeforeDelete : defaults_1.DefaultSetting.timeBeforeDelete;
        pack.timeoutTick = window.setTimeout(() => {
            moveOn();
        }, waitTime);
    }
    else {
        // Else, move on as usual
        moveOn();
    }
};
exports.handleFunction = handleFunction;
